import { Typography, Box, Tooltip } from "@mui/material";
import pluralize from "pluralize";

export const TagLegend = ({
  theme,
  entityName,
}: {
  theme: any;
  entityName: string;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 3,
        mt: 3,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Added tags */}
      <Tooltip
        title={`These tags will be added to all selected ${pluralize(
          entityName
        ).toLowerCase()}.`}
        placement="top"
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "help" }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              backgroundColor: theme.palette.success.light,
              borderRadius: "50%",
              flexShrink: 0,
            }}
          />
          <Typography variant="caption" color="text.secondary">
            Added
          </Typography>
        </Box>
      </Tooltip>

      {/* On all entities */}
      <Tooltip
        title={`These tags will exist on all selected ${pluralize(
          entityName.toLowerCase()
        )}.`}
        placement="top"
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "help" }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              backgroundColor: theme.palette.primary.main,
              borderRadius: "50%",
              flexShrink: 0,
            }}
          />
          <Typography variant="caption" color="text.secondary">
            On all {pluralize(entityName).toLowerCase()}
          </Typography>
        </Box>
      </Tooltip>

      {/* On some entities */}
      <Tooltip
        title={
          <>
            These tags will remain on some {pluralize(entityName).toLowerCase()}
            .
            <br />
            (Click the tag to apply it to all selected{" "}
            {pluralize(entityName).toLowerCase()})
          </>
        }
        placement="top"
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "help" }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              backgroundColor: theme.palette.grey[300],
              borderRadius: "50%",
              flexShrink: 0,
            }}
          />
          <Typography variant="caption" color="text.secondary">
            On some {pluralize(entityName).toLowerCase()}
          </Typography>
        </Box>
      </Tooltip>

      {/* Removed */}
      <Tooltip
        title={`These tags will be removed from all selected ${entityName.toLowerCase()}s. (Click the tag to re-add it)`}
        placement="top"
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "help" }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              border: `1px solid ${theme.palette.grey[400]}`,
              borderRadius: "50%",
              flexShrink: 0,
            }}
          />
          <Typography variant="caption" color="text.secondary">
            Removed
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};
